import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import startCase from 'lodash/startCase';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

const ItemHub = ({ locations = {}, isMobile = false }) => {
  const [shownLocations, setShownLocations] = useState(!isMobile);

  useEffect(() => {
    setShownLocations(!isMobile);
  }, [isMobile]);

  return (
    <>
      <h3
        onClick={() => setShownLocations(!shownLocations)}
        onKeyPress={() => setShownLocations(!shownLocations)}
        role="presentation"
      >
        <div className="toggle-location">
          {locations.region}{' '}
          <span className="pull-right">
            <FontAwesomeIcon
              icon={shownLocations ? faAngleUp : faAngleDown}
              size="sm"
            />
          </span>
        </div>
        {shownLocations ? (
          <div className="row">
            {locations.nearMeArea.map((areas, area) => (
              <div
                className="sub-location col-xs-12 col-sm-3 col-md-3"
                key={area}
              >
                {areas.areaName}
                <ul className="nearme-areas">
                  {areas.area.map((eachLocation) => (
                    <li key={eachLocation.id}>
                      <Link href={eachLocation.nearMeLocationPath} passHref>
                        <a>{startCase(eachLocation.nearMeLocationName)}</a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ) : null}
      </h3>

      <style jsx>{`
        .sub-location {
          margin-top: 15px;
          text-transform: capitalize;
        }
        .nearme-areas {
          margin-top: 10px;
        }
        a {
          color: black !important;
          text-decoration: none;
        }
        ul li::marker {
          color: black;
        }

        .toggle-location {
          border: 1px solid grey;
          cursor: pointer;
          padding: 10px;
        }
        .pull-right{
          float right;
        }
        .nearme-areas {
          list-style: none;
          padding-left: 0;
        }

        ul.nearme-areas li a {
          color: #212529;
          cursor: pointer;
          font-size: 16px;
          padding-bottom: 4px;
          display: block;
        }
      `}</style>
    </>
  );
};

ItemHub.propTypes = {
  isMobile: PropTypes.bool,
  locations: PropTypes.object,
};

export default ItemHub;
